// data.js (or within the same file if you prefer)
import img from '../assets/images/panda.jpg';
import img1 from '../assets/images/officestudio.png';
import img2 from '../assets/images/funny.jpg';
import img3 from '../assets/images/silencio.png';
import img4 from '../assets/images/wix.jpg';
import img5 from '../assets/images/silencio.png';
import img6 from '../assets/images/wix.jpg';
import img7 from '../assets/images/silencio.png';
import video from '../video/Shakil Mahnoor – VISIONARY ARTIST.mp4'
import video1 from '../video/AHMA _ Explore your digital Self, with your own personalized AI.mp4'
import video2 from '../video/ZETR.mp4'
export const slider1 = [
  {
    color: "#e3e5e7",
    type: 'image',
    src: img,
  },
  {
    color: "#d6d7dc",
    type: 'image',
    src: img1,
  },
  {
    color: "#e3e3e3",
    type: 'video',
    videoId: video, // Example video ID
  },
  {
    color: "#d6d7dc",
    type: 'image',
    src: img3,
  },

];

export const slider2 = [
  {
    color: "#d4e3ec",
    type: 'image',
    src: img4,
  },
  {
    color: "#e5e0e1",
    type: 'video',
    videoId: video1, // Example video ID
  },
  {
    color: "#d7d4cf",
    type: 'image',
    src: img6,
  },
  {
    color: "#e1dad6",
    type: 'video',
    videoId: video2, // Example video ID
  },
 
  
 
];
